import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { MAPPABLE_FIELDS_RESOURCE_KEYS } from "../../MessageTemplates/utils/constants";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const MappableFieldsDescriptionModal = ({
  open,
  onClose,
  resources,
  mappableFields,
}) => {
  const onCopy = (field) => {
    navigator.clipboard.writeText(field);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>{resources["MappableFieldsInfoModalTitle"]}</span>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} style={{ maxHeight: "500px" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>{resources["MappableFieldName"]}</strong>
                </TableCell>
                <TableCell>
                  <strong>{resources["Description"]}</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mappableFields.map((field, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Box
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      {field}
                      <IconButton onClick={() => onCopy(field)} size="small">
                        <FileCopyIcon color="primary" />
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {resources[MAPPABLE_FIELDS_RESOURCE_KEYS[field]]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default MappableFieldsDescriptionModal;
